import axios from "axios";

export const state = {
    staff: [],
    save_status: false,
};
export const getters = {
    Staff: state => state.staff.data,
    StaffSave: state => state.save_status,
};
export const mutations = {
    SET_STAFF(state, newValue) {
        state.staff = newValue
    },

    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
};
export const actions = {
    addStaff({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('staff', payload).then(() => {
            dispatch('fetchStaff');
            let message = { 'msg': ` Staff added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Staff " }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteStaff({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`staff/${payload.id}`).then(() => {
            dispatch('fetchStaff');
            let message = { 'msg': `Staff  record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Staff
    editStaff({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`staff/${payload.id}`, payload).then(() => {
            dispatch('fetchStaff');
            let message = { 'msg': `Details of Staff ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Fetch Staff

    fetchStaff({ commit }) {
        axios.get('staff').then(ec_res => {
            commit('SET_STAFF', ec_res.data)
        })
    },

};